<template>
<div id="shengming">
     <!-- 头部组件 -->
     <component :is="header_"></component>
     <!--  -->
    <el-container class="el-container-vh" style="border: 1px solid #eee">
      <!-- 侧栏组件 -->
      <component :is="celan"></component>
      
      <el-container>
        <el-main>
             <h3 style="margin-bottom: 12px;color: #606266;">声明：</h3>
             <div style="color: red;margin-left: 29px;">
                源码，软件仅供学习和技术交流，请勿用于商业及非法用途，否则产生的一切后果将由您自己承担！
             </div>
        </el-main>
      </el-container>
    </el-container>
</div>
</template>

<script>
//头部组件
import header_ from './header_.vue'
import celan from './celan.vue'
export default {
  name: 'shengming',
   data() {
      return {
        header_:header_,
        celan:celan,
      }
    },
    methods: {

    },
    created(){

    }
}
</script>


<style scoped>
.el-container-vh{
  height: 100vh;
}
@media screen and (max-width: 800px) {
  .el-container-vh{
    height: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/shengming.vue